import Router from './routes';
import ThemeConfig from './theme';
import useAuth from './hooks/useAuth';
import ScrollToTop from './components/ScrollToTop';
import GoogleAnalytics from './components/GoogleAnalytics';
import NotistackProvider from './components/NotistackProvider';
import ThemePrimaryColor from './components/ThemePrimaryColor';

export default function App() {
  const { isInitialized } = useAuth();

  return (
    <ThemeConfig>
      <ThemePrimaryColor>
        <NotistackProvider>
          <ScrollToTop />
          <GoogleAnalytics />
          {isInitialized ? <Router /> : null}
        </NotistackProvider>
      </ThemePrimaryColor>
    </ThemeConfig>
  );
}
